export default __webpack_public_path__ + "static/media/export.9ed8b036.svg";